import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, find, isEmpty, has } from 'lodash';
import AttendeeFooter from './attendee-footer';
import GuestList from './GuestList';
import VisibilityModal from './VisibilityModal';
import { ListingImage } from '../elements-image/listing-image';
import { createAttendee, updateAttendee } from '../app-main/actions/attendees';
import AttendeeModalContainer from './attendee-modal';
import AttendeeRsvp from './attendee-rsvp';
import AttendeeResponse from './attendeee-response';
import AttendeeListCompact from './attendee-list-compact';
import AttendeePhotoBlock from './AttendeePhotoBlock';
import { NotificationBanner } from '../elements-banner/notification-banner';
import * as types from '../app-main/constants/action-types';
import { push } from 'react-router-redux';
import AttendeeDateBlock from './AttendeeDateBlock';
import ParkingInfo from '../app-parking-info/ParkingInfo';
import HostRulesAgree from '../app-bookings-request/HostRulesAgree';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

/* global: PSSessions */
class AttendeePublic extends React.Component {
  static rsvpAnalyticsData (status) {
    if ('going' === status) {
      return {
        modalToDisplay: 'rsvpAcceptModal',
        source: 'rsvp_accept_header',
        rsvpStatus: 'rsvp-accept'
      };
    }

    return {
      modalToDisplay: 'rsvpDeclineModal',
      source: 'rsvp_decline_header',
      rsvpStatus: 'rsvp-decline'
    };
  }

  constructor (props) {
    super(props);

    this.attendeeListRef = null;

    this.redirectUserToHomepage = this.redirectUserToHomepage.bind(this);
    this.getAccessToken = this.getAccessToken.bind(this);
    this.buildAnalyticProps = this.buildAnalyticProps.bind(this);
    this.getDirections = this.getDirections.bind(this);
    this.setMapPin = this.setMapPin.bind(this);
    this.createMapBlock = this.createMapBlock.bind(this);
    this.handleResponseModalFlow = this.handleResponseModalFlow.bind(this);
    this.showChangeResponseModal = this.showChangeResponseModal.bind(this);
    this.handleChangeResponseModal = this.handleChangeResponseModal.bind(this);
    this.scrollToAttendeeSection = this.scrollToAttendeeSection.bind(this);
    this.dispatchCreateAttendees = this.dispatchCreateAttendees.bind(this);
    this.handleAcceptInvitation = this.handleAcceptInvitation.bind(this);
    this.handleDeclineInvitation = this.handleDeclineInvitation.bind(this);
    this.getNotificationMessage = this.getNotificationMessage.bind(this);
    this.openRenderModal = this.openRenderModal.bind(this);
    this.redirectToEdit = this.redirectToEdit.bind(this);
    this.redirectToShare = this.redirectToShare.bind(this);
    this.isUserGuest = this.isUserGuest.bind(this);
    this.getUserRsvpStatus = this.getUserRsvpStatus.bind(this);
    this.handleListingLink = this.handleListingLink.bind(this);
    this.setGuestListRef = this.setGuestListRef.bind(this);
    this.redirectToBookingDetails = this.redirectToBookingDetails.bind(this);
  }

  componentDidMount () {
    this.createMapBlock();
  }

  /* helpers */
  getUserRsvpStatus () {
    const userSsoId = get(this.props, 'profile.SSOid');

    return get(this.props, `attendees.data[${userSsoId}].rsvp`);
  }

  getAccessToken () {
    return get(this.props, 'auth.accessToken');
  }

  getNotificationMessage () {
    const newInviteCount = get(this.props, 'attendees.addedPendingCount', 0);
    const inviteCopy = 1 < newInviteCount
      ? this.props.intl.formatMessage({ id: 'invite.attendee_public.invites_were', defaultMessage: 'Invites were' })
      : this.props.intl.formatMessage({ id: 'invite.attendee_public.invites_was', defaultMessage: 'Invite was' });

    if (newInviteCount) {
      const { dispatch } = this.props;

      if (this.clearAttendeeCount) {
        clearTimeout(this.clearAttendeeCount);
        this.clearAttendeeCount = null;
      }

      this.clearAttendeeCount = setTimeout(() => {
        dispatch({ type: types.ATTENDEE_CLEAR_INVITE_COUNT });
      }, 5000);

      return (
        <span className="text-center">
          <i className="ico icon-yes margin-sm-right" />
          <FormattedMessage
            id='invite.attendee_public.invite_count_sent'
            defaultMessage=' {count} {copy} sent'
            values={{
              count: newInviteCount,
              copy: inviteCopy
            }}
          />
        </span>
      );
    }

    return '';
  }

  redirectUserToHomepage () {
    analyticsIntegrations.publicAttendee('attendee details: explore spaces', this.buildAnalyticProps());

    setTimeout(function makeLoginLinkRedirect () {
      const fullLink = location.origin;
      location.href = fullLink;
    }, 0);
  }

  dispatchCreateAttendees (bookingId, status, callback = () => {}) {
    const { dispatch } = this.props;
    const booking = get(this.props, 'booking.booking');
    const { source, rsvpStatus } = AttendeePublic.rsvpAnalyticsData(status);
    const token = this.getAccessToken();

    dispatch(createAttendee(bookingId, status, token, () => {
      const analyticsProps = {
        event: 'attendee details invite response submitted',
        booking,
        currentStatus: rsvpStatus,
        source
      };
      analyticsIntegrations.rsvpEvent(analyticsProps);
      return callback();
    }));
  }

  handleResponseModalFlow (status) {
    const token = this.getAccessToken();
    // this is only used for analytics
    const { toggleModal } = this.props;
    const booking = get(this.props, 'booking.booking');
    const bookingId = get(booking, '_id');
    const modalToDisplay = 'going' === status ? 'rsvpAcceptModal' : 'rsvpDeclineModal';

    if (!token) {
      const { source, rsvpStatus } = AttendeePublic.rsvpAnalyticsData(status);

      const analyticsProps = {
        event: 'signup form viewed',
        booking,
        currentStatus: rsvpStatus,
        source
      };

      analyticsIntegrations.rsvpEvent(analyticsProps);

      return toggleModal('signUpLiteModal', (newUser, profileRes = {}, profileObj = {}) => {

        if (newUser) {
          const analyticsPropsAccount = {
            event: 'account created',
            label: 'invite_rsvp',
            booking,
            currentStatus: rsvpStatus,
            method: 'email',
            source,
            profile: {
              SSOid: profileRes.SSOid,
              username: profileObj.username,
              date_created: profileRes.date_created
            }
          };

          analyticsIntegrations.rsvpEvent(analyticsPropsAccount);
          this.dispatchCreateAttendees(bookingId, status);

          return toggleModal('avatarModal', () => {
            return toggleModal(modalToDisplay);
          });
        }

        // not a new user, and logged in
        toggleModal('');

        return this.dispatchCreateAttendees(bookingId, status, () => {
          return toggleModal(modalToDisplay);
        });
      });
    }

    // already logged in
    this.dispatchCreateAttendees(bookingId, status, () => {
      return toggleModal(modalToDisplay);
    });
  }

  showChangeResponseModal () {
    return this.props.toggleModal('changeRsvpModal');
  }

  previousStatus () {
    // at this point we know they are logged in
    // there previous status could potentially equal the old one
    const attendees = get(this.props, 'attendees.data');
    const SSOid = get(this.props, 'profile.SSOid');

    if (attendees[SSOid]) {
      return 'going';
    }

    return 'not_going';
  }

  handleChangeResponseModal (rsvpFlag) {
    const { dispatch } = this.props;
    const booking = get(this.props, 'booking.booking');
    const bookingId = get(booking, '_id');
    const accessToken = this.getAccessToken();
    const modalToDisplay = 'going' === rsvpFlag ? 'rsvpAcceptModal' : 'rsvpDeclineModal';
    const previousStatus = this.previousStatus();

    return () => {
      dispatch(updateAttendee(bookingId, rsvpFlag, accessToken, () => {
        const { source, rsvpStatus } = AttendeePublic.rsvpAnalyticsData(rsvpFlag);
        const analyticsProps = {
          event: 'attendee details invite response submitted',
          booking,
          currentStatus: rsvpStatus,
          previousStatus,
          source
        };
        analyticsIntegrations.rsvpEvent(analyticsProps);
        return this.props.toggleModal(modalToDisplay);
      }));
    };
  }

  handleAcceptInvitation () {
    return this.handleResponseModalFlow('going');
  }

  handleDeclineInvitation () {
    return this.handleResponseModalFlow('not_going');
  }

  handleListingLink () {
    // maybe add anayltics here
    const listingId = get(this.props, 'booking.booking.listing_id');

    window.open(`/pages/listings/${listingId}`, '_blank');
  }

  buildAnalyticProps (extraAnalyticProps) {
    const booking = get(this.props, 'booking.booking');
    const bookingId = get(booking, '_id');
    const wifiInstructions = get(booking, 'space.wifi_instructions');
    const gettingThere = get(booking, 'space.getting_there');

    return {
      label: bookingId,
      wifi: !!wifiInstructions,
      getting_there: !!gettingThere,
      ...extraAnalyticProps
    };
  }

  getDirections () {
    analyticsIntegrations.publicAttendee('attendee details: get directions', this.buildAnalyticProps());

    const booking = get(this.props, 'booking.booking');
    const spaceAddress = get(booking, 'space.address');
    const address = encodeURIComponent(spaceAddress);
    const googleLink = `https://maps.google.com/maps?daddr=${address}`;

    window.location.href = googleLink;
  }
  /* end helpers */


  openRenderModal () {
    console.log('VisibilityModal');
    return this.props.toggleModal('VisibilityModal');
  }

  setGuestListRef (ref) {
    this.attendeeListRef = ref;
  }

  /* map render functions */
  setMapPin (map) {
    const fnbPin = '/web-2/assets/images/map-pin.png?v=rb';
    const booking = get(this.props, 'booking.booking');
    const { lat, lon } = get(booking, 'space.loc', {});
    const bookingId = get(booking, '_id');

    const marker = new google.maps.Marker({
      map,
      draggable: false,
      position: { lat, lng: lon },
      icon: fnbPin,
      disableAutoPan: true,
      pinID: bookingId
    });

    return marker.setIcon(fnbPin);
  }

  createMapBlock () {
    const booking = get(this.props, 'booking.booking');
    const { lat, lon } = get(booking, 'space.loc', {});

    const mapOptions = {
      center: { lat, lng: lon },
      zoom: 14,
      scrollwheel: false,
      draggable: false,
      disableDoubleClickZoom: true,
      zoomControl: false,
      disableDefaultUI: true
    };

    const map = new google.maps.Map(document.getElementById('attendee-map-canvas'), mapOptions);
    this.setMapPin(map);

    return map;
  }
  /* end map render functions */

  isUserGuest () {
    const userSsoId = get(this.props, 'profile.SSOid');
    const guestSsoId = get(this.props, 'booking.booking.guest.ssoid');

    return userSsoId === guestSsoId;
  }

  scrollToAttendeeSection () {
    const offsetTop = get(this, 'attendeeListRef.offsetTop');

    window.scrollTo(0, offsetTop - 80);
  }

  redirectToEdit () {
    const bookingId = get(this.props, 'booking.booking._id');

    this.props.dispatch(push(`/invite/add/${bookingId}`));
  }

  redirectToShare () {
    const bookingId = get(this.props, 'booking.booking._id');

    this.props.dispatch(push(`/invite/send/${bookingId}`));
  }

  redirectToBookingDetails () {
    const bookingId = get(this.props, 'booking.booking._id');

    this.props.dispatch(push(`/inbox/${bookingId}`));
  }

  render () {
    const booking = get(this.props, 'booking.booking');
    const userSsoId = get(this.props, 'profile.SSOid');
    const guestSsoId = get(booking, 'guest.ssoid');
    const isUserGuest = userSsoId === guestSsoId;
    const accessToken = this.getAccessToken();
    const isLoggedIn = !!accessToken;
    const { getting_there: gettingThere, wifi_instructions: wifiInstructions } = get(booking, 'space');
    const { city, unit, state, street, zip } = get(booking, 'space.address_parts', {});
    const { guest_title: guestTitle, guest_notes: guestNotes } = get(booking, 'public_fields', {});
    const guestAvatar = get(booking, 'guest.avatar');
    const userAvatar = get(this.props, 'profile.data.avatar_url');
    const guestFirstName = get(booking, 'guest.name.first');
    const attendees = get(this.props, 'attendees.data');
    const pendingAttendees = get(this.props, 'attendees.pending');
    const pathname = get(this.props, 'location.pathname');
    const redirectLocation = pathname ? `?dest=${encodeURIComponent(pathname)}` : '';
    const usersRsvp = find(attendees, (attendee) => get(attendee, 'sso-id') === userSsoId);
    const userIsGoing = 'going' === get(usersRsvp, 'rsvp');
    const hasUserRSVP = !!usersRsvp;
    const isAttendeesAndPendingEmpty = isEmpty(attendees) && isEmpty(pendingAttendees);
    const notificationMessage = this.getNotificationMessage();
    const rsvpStatus = this.getUserRsvpStatus();
    const listingTitle = get(this.props, 'booking.booking.listing.title');
    const listingImageExternalId = get(this.props, 'booking.booking.listing.images[0].external_id');
    const shareState = get(booking, 'share_state');
    const listingParkingData = get(booking, 'listing.parking_info');

    if (guestTitle) {
      (document.getElementsByTagName('title')[0] || {}).textContent = `${guestTitle} | Peerspace`;
    }

    const listingObj = get(this.props, 'booking.booking.listing', {});
    const productionDetails = get(listingObj, 'production_details', {});
    const isProductionListing = 'Production' === get(listingObj, 'use_type');
    const hostRulesData = {
      listingRules: get(listingObj, 'rules', ''),
      min_age: get(listingObj, 'min_age', ''),
      ...(isProductionListing && productionDetails),
      surveillanceData: get(listingObj, 'surveillance_info', {})
    };
    const country = get(listingObj, 'country', '');

    return (
      <SharedIntlProviderHOC>
        <div className="AttendeePublic ps-container-lg-margin ps-container-fixed">
          { notificationMessage &&
            <NotificationBanner
              showClose
              message={notificationMessage}
            />
          }
          { !isUserGuest &&
            <>
              <div className="ps-row">
                { !usersRsvp &&
                  <AttendeeRsvp
                    attendees={attendees}
                    className="col-xs-12 col-md-6"
                    guestAvatar={guestAvatar}
                    guestFirstName={guestFirstName}
                    handleAcceptInvitation={this.handleAcceptInvitation}
                    handleDeclineInvitation={this.handleDeclineInvitation}
                    isLoggedIn={isLoggedIn}
                    redirectLocation={redirectLocation}
                    scrollToAttendeeSection={this.scrollToAttendeeSection}
                  />
                }

                { !!usersRsvp &&
                  <AttendeeResponse
                    attendees={attendees}
                    guestAvatar={guestAvatar}
                    className="col-xs-12 col-md-6"
                    userAvatar={userAvatar}
                    guestFirstName={guestFirstName}
                    showChangeResponseModal={this.showChangeResponseModal}
                    scrollToAttendeeSection={this.scrollToAttendeeSection}
                    isLoggedIn={isLoggedIn}
                    isGoing={userIsGoing}
                    hasUserRSVP={hasUserRSVP}
                    redirectLocation={redirectLocation}
                  />
                }
                <hr className='col-xs-12'/>
              </div>
            </>
          }

          <div className="style-2 remove-bootstrap">
            <div className="content-container flex column center">
              { isUserGuest && 'private' === shareState &&
                <div data-testing-id="private-state-message">
                  <h2 className="attendee-title flex center text-danger no-top-margin">
                    <FormattedMessage id='invite.attendee_public.private_page' defaultMessage='This page is set to private' />
                  </h2>

                  <hr />
                </div>
              }

              <div className="flex row space-between middle flex-wrap margin-xxl-bottom">
                <h1 className="no-bottom-margin no-top-margin" data-testing-id="header">
                  {
                    guestTitle ||
                    <FormattedMessage
                      id="invite.attendee_public.event"
                      defaultMessage="{name}’s Event"
                      values={{
                        name: guestFirstName
                      }}
                    />
                  }
                </h1>

                {
                  isUserGuest &&
                  <div className="organizer-button-container flex flex-wrap" data-testing-id="manage-invitation-container">
                    <button
                      className="btn btn-link margin-lg-right remove-click-styling"
                      onClick={this.openRenderModal}
                    >
                      <i className="ico ico-md small-padding-right icon-gear" />
                      <FormattedMessage id="invite.attendee_public.settings" defaultMessage="Settings" />
                    </button>

                    <div>
                      <button
                        className="btn btn-default margin-lg-right"
                        onClick={this.redirectToBookingDetails}
                      >
                        <FormattedMessage id="invite.attendee_public.booking_details" defaultMessage="Booking Details" />
                      </button>

                      <button
                        className="btn btn-default margin-lg-right"
                        onClick={this.redirectToEdit}
                      >
                        <FormattedMessage id="invite.attendee_public.edit_invite" defaultMessage="Edit Invite" />
                      </button>

                      <button className="btn btn-primary" onClick={this.redirectToShare}>
                        <FormattedMessage id="invite.attendee_public.share_invite" defaultMessage="Share Invite" />
                      </button>
                    </div>
                  </div>
                }
              </div>

              <div className="flex row space-between">
                <div className="guestEventDetails flex column">
                  { isAttendeesAndPendingEmpty && isUserGuest &&
                    <p className="list-empty-text margin-xxl-bottom" data-testing-id="no-attendees-container">
                      <span>
                        <FormattedMessage id="invite.attendee_public.no_rsvp" defaultMessage="No one has RSVP’d yet." />
                      </span>
                      &nbsp;
                      <button className="btn-link" onClick={this.redirectToShare}>
                        <FormattedMessage id="invite.attendee_public.share_ur_invite" defaultMessage="Share your invite" />
                      </button>
                      &nbsp;
                      <span>
                        <FormattedMessage id="invite.attendee_public.give_access" defaultMessage="with guests to give them access to your event details." />
                      </span>
                    </p>
                  }

                  { !isAttendeesAndPendingEmpty && isUserGuest &&
                    <AttendeeListCompact
                      className="flex left margin-xxl-bottom"
                      attendees={attendees}
                      pendingAttendees={pendingAttendees}
                      onClick={this.scrollToAttendeeSection}
                      hasUserRSVP={hasUserRSVP}
                      isLoggedIn={isLoggedIn}
                      showViewGuestListLink
                    />
                  }

                  <AttendeeDateBlock booking={booking} />

                  <div className="guestDescription margin-xxl-bottom" data-testing-id="notes">
                    {
                      guestNotes ||
                      <FormattedMessage id="invite.attendee_public.check_space" defaultMessage="Check out the space I booked on Peerspace. Let me know if you can make it!" />
                    }
                  </div>
                </div>

                <div className="imageContainer">
                  <ListingImage
                    imgId={listingImageExternalId}
                    ratio={1.689}
                    widths={[545]}
                    defaultWidth={545}
                    defaultHeight={454}
                    style="img-responsive"
                    sizes="50vw"
                    alt="Peerspace"
                  />

                  <button
                    className="margin-sm-top btn-link"
                    onClick={this.handleListingLink}
                  >
                    { listingTitle }
                  </button>
                </div>
              </div>

              <section className="twoColumnField">
                <div className="title">
                  <h5 className="no-top-margin">
                    <FormattedMessage id="invite.attendee_public.address" defaultMessage="Address" />
                  </h5>
                </div>

                <div className="value hyphenate">
                  <div>{street}, {unit}</div>
                  <div>{city}, {state}, {zip}</div>
                  <button
                    className="btn-link"
                    onClick={this.getDirections}
                  >
                    <FormattedMessage id="invite.attendee_public.get_directions" defaultMessage="Get directions to the space" />
                  </button>
                </div>
              </section>

              <div id="attendee-map-canvas" className="attendee-map-canvas margin-xxl-bottom" />

              { gettingThere &&
                <section className="twoColumnField">
                  <div className="title">
                    <h5 className="no-top-margin">
                      <FormattedMessage id="invite.attendee_public.arrival_instructions" defaultMessage="Arrival Instructions" />
                    </h5>
                  </div>

                  <div className="value">{ gettingThere }</div>
                </section>
              }

              { has(listingParkingData, 'is_available') &&
                <section className="twoColumnField">
                  <div className="title">
                    <h5 className="no-top-margin">
                      <FormattedMessage id="invite.attendee_public.parking" defaultMessage="Parking" />
                    </h5>
                  </div>

                  <div className="value flex-basis-100">
                    <ParkingInfo parkingInfo={listingParkingData} />
                  </div>
                </section>
              }

              { wifiInstructions &&
                <section className="twoColumnField">
                  <div className="title">
                    <h5 className="no-top-margin">
                      <FormattedMessage id="invite.attendee_public.wifi_access" defaultMessage="Wifi Access" />
                    </h5>
                  </div>

                  <div className="value">{ wifiInstructions }</div>
                </section>
              }

              <section className="twoColumnField">
                <div className="title">
                  <h5 className="no-top-margin">
                    <FormattedMessage id="invite.attendee_public.the_space" defaultMessage="The Space" />
                  </h5>
                </div>

                <AttendeePhotoBlock />
              </section>

              <section className="twoColumnField guest-list-section" ref={ this.setGuestListRef }>
                <div className="title">
                  <h5 className="no-top-margin">
                    <FormattedMessage id="invite.attendee_public.guest_list" defaultMessage="Guest List" />
                  </h5>
                </div>

                <GuestList
                  attendees={attendees}
                  pendingAttendees={pendingAttendees}
                  isUserGuest={isUserGuest}
                  hasUserRSVP={hasUserRSVP}
                  isLoggedIn={isLoggedIn}
                  redirectToShare={this.redirectToShare}
                  handleAcceptInvitation={this.handleAcceptInvitation}
                  handleDeclineInvitation={this.handleDeclineInvitation}
                  redirectLocation={redirectLocation}
                />
              </section>

              <section className="twoColumnField">
                <div className="title rules">
                  <h5 className="no-top-margin">
                    <FormattedMessage id="invite.attendee_public.host_rules" defaultMessage="Host Rules & Disclosures" />
                  </h5>
                </div>

                <div>
                  <HostRulesAgree hostRulesData={hostRulesData} displayRulesOnly />
                </div>
              </section>
            </div>
          </div>

          <hr />

          <AttendeeFooter redirUserToHomepage={this.redirectUserToHomepage} />

          <VisibilityModal
            whichModal={this.props.whichModal}
            whichModalCb={this.props.whichModalCb}
            toggleModal={this.props.toggleModal}
          />

          <AttendeeModalContainer
            {...this.props}
            booking={booking}
            guestFirstName={guestFirstName}
            whichModal={this.props.whichModal}
            whichModalCb={this.props.whichModalCb}
            toggleModal={this.props.toggleModal}
            handleChangeResponseModal={this.handleChangeResponseModal}
            rsvpStatus={rsvpStatus}
          />
        </div>
      </SharedIntlProviderHOC>
    );
  }
}

AttendeePublic.propTypes = {
  params: PropTypes.object,
  dispatch: PropTypes.func
};

function mapStateToProps (state) {
  const { attendees, booking, auth, profile } = state;

  return {
    attendees,
    booking,
    auth,
    profile
  };
}

export default injectIntl(connect(mapStateToProps)(AttendeePublic));
